module.exports = "pegasus/assets/hexline-pinterest.png";